import { STATUS_META, ROLE_META } from '../../utils/constants';

/**
 * Status Badge Component
 * @param {string} status - Status key (e.g., 'new', 'data_review')
 * @param {boolean} showIcon - Show icon prefix
 */
export function StatusBadge({ status, showIcon = true }) {
  const meta = STATUS_META[status];
  if (!meta) return null;

  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      background: meta.bg,
      color: meta.color,
      padding: "6px 12px",
      borderRadius: 8,
      fontWeight: 700,
      fontSize: 12,
      whiteSpace: "nowrap",
    }}>
      {showIcon && <span>{meta.icon}</span>}
      <span>{meta.label}</span>
    </span>
  );
}

/**
 * Role Badge Component
 * @param {string} role - Role key (e.g., 'admin', 'marketer')
 */
export function RoleBadge({ role }) {
  const meta = ROLE_META[role];
  if (!meta) return null;

  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      background: `${meta.color}20`,
      color: meta.color,
      padding: "4px 10px",
      borderRadius: 6,
      fontWeight: 700,
      fontSize: 11,
      whiteSpace: "nowrap",
    }}>
      <span>{meta.icon}</span>
      <span>{meta.label}</span>
    </span>
  );
}

/**
 * Online Status Indicator
 * @param {boolean} isOnline - Online status
 * @param {string} lastActive - Last active timestamp
 */
export function OnlineIndicator({ isOnline, lastActive }) {
  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      fontSize: 11,
      color: isOnline ? "#10b981" : "#64748b",
    }}>
      <span style={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: isOnline ? "#10b981" : "#475569",
        boxShadow: isOnline ? "0 0 8px #10b981" : "none",
      }} />
      {isOnline ? "متصل الآن" : lastActive ? `آخر نشاط: ${formatTimeAgo(lastActive)}` : "غير نشط"}
    </span>
  );
}

function formatTimeAgo(date) {
  if (!date) return 'غير معروف';
  const now = new Date();
  const past = new Date(date);
  const diffMs = now - past;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return 'الآن';
  if (diffMins < 60) return `منذ ${diffMins} دقيقة`;
  if (diffHours < 24) return `منذ ${diffHours} ساعة`;
  if (diffDays < 7) return `منذ ${diffDays} يوم`;
  return past.toLocaleDateString('ar-AE');
}
